import classNames from "classnames";
import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";
import Icon from "../Icon";
import Text from "../Text";

const ChipInput = ({
  title = "",
  chips = [], // Predefined chips array
  className,
  onChangeHandler,
}) => {
  const [selectedChip, setSelectedChip] = useState(null);

  // Update the parent component with the selected chip when it changes
  useEffect(() => {
    onChangeHandler(selectedChip);
  }, [selectedChip]);

  const toggleChipSelection = (chip) => {
    setSelectedChip((prev) => (prev === chip ? null : chip));
  };

  return (
    <div
      className={twMerge(
        "chip-input relative w-full flex flex-col gap-3",
        className
      )}
    >
      <label className="font-encode-sans text-14 font-medium text-senate leading-20 tracking-[0.28px]">
        {title}
      </label>

      <div className="flex flex-row items-center min-h-14 justify-start overflow-hidden font-encode-sans gap-3 flex-wrap">
        <div className="flex flex-wrap gap-3 flex-grow">
          {chips?.map((chip, index) => (
            <div
              key={index}
              className={classNames(
                "flex items-center gap-2 rounded-full border-2 border-atelier px-[16px] py-[8px] cursor-pointer",
                {
                  "text-richcarmine border-richcarmine": selectedChip === chip,
                }
              )}
              onClick={() => toggleChipSelection(chip)}
            >
              <Text
                type="paragraph"
                className={classNames(
                  "text-16 text-gunmetal font-encode-sans !font-medium capitalize leading-20 tracking-[0.32px]",
                  {
                    "text-richcarmine": selectedChip === chip,
                  }
                )}
              >
                {chip.label}
              </Text>

              {selectedChip === chip ? (
                <div className="w-[18px] lg:w-[24px] h-[18px] lg:h-[24px] flex items-center shrink-0 rounded-full bg-richcarmine">
                  <Icon type="checkmark-rounded-bg" height="30" width="30" />
                </div>
              ) : (
                <div className="w-[18px] lg:w-[24px] h-[18px] lg:h-[24px] flex shrink-0 border-2 border-coarse-wool rounded-full" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChipInput;
